import React from 'react';
import './BusyIndicator.scss';

const BusyIndicator = (props) => {
    return (
        <div className="busy-indicator">
            <div className="loader"></div>
        </div>);
}

export default BusyIndicator;


// WEBPACK FOOTER //
// ./Src/Shared/Helpers/BusyIndicator/BusyIndicator.jsx